import React, { useEffect, useRef, useState } from "react";

export const NewSealNumberComponent = React.forwardRef((props, ref) => {
  const { name, disabled, read_only, onChange, defaultValue } = props;

  // Using a ref to directly interact with the DOM element
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  // Add state to manage the input value
  const [value, setValue] = useState(defaultValue || "");
  const [originalSeal, setOriginalSeal] = useState("");

  useEffect(() => {
    if (ref) {
      ref.current = inputRef.current; // Assigning the DOM element to the forwarded ref
    }
  }, [ref]);

  // Find the original seal number from sibling elements
  useEffect(() => {
    if (containerRef.current) {
      // Navigate up to find the SortableItem, then find the seal-number input
      const sortableItem = containerRef.current.closest(".SortableItem");
      if (sortableItem) {
        // The seal-number is 3 siblings up (new-seal -> replace -> sealed/broken -> seal-number)
        let sibling = sortableItem.previousElementSibling;
        for (let i = 0; i < 3 && sibling; i++) {
          const sealInput = sibling.querySelector(".seal-number-input");
          if (sealInput && sealInput.value) {
            setOriginalSeal(sealInput.value);
            break;
          }
          sibling = sibling.previousElementSibling;
        }
      }
    }
  }, []);

  // Update state when defaultValue changes (e.g., when loading from draft)
  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  const formatLabel = (label) => {
    return label;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    // Call the onChange prop if provided
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="form-group new-seal-number" ref={containerRef}>
      {/* Show seal change indicator when there's a saved value from draft */}
      {value && originalSeal && (
        <div 
          className="seal-change-indicator"
          style={{
            backgroundColor: "#e8f5e9",
            border: "1px solid #4caf50",
            borderRadius: "6px",
            padding: "8px 12px",
            marginBottom: "10px",
            fontSize: "14px",
            color: "#2e7d32",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          <span style={{ fontSize: "16px" }}>🔄</span>
          <span>
            <strong>Seal changed:</strong> {originalSeal} → {value}
          </span>
        </div>
      )}
      <label className="form-label">
        <span
          dangerouslySetInnerHTML={{ __html: formatLabel(props.data.label) }}
        ></span>
        {props.data.required && (
          <span className="label-required badge badge-danger">Required</span>
        )}
      </label>
      <input
        ref={inputRef} // Using the ref here
        type="text"
        className="form-control new-seal-number-input"
        name={name}
        disabled={disabled}
        readOnly={read_only}
        value={value} // Use controlled value instead of defaultValue
        onChange={handleChange} // Add onChange handler
      />
    </div>
  );
});
